import React from 'react'
import { Query } from 'react-apollo'
import VIDEO_UPLOAD_LINK_QUERY from './VideoUploadLinkQuery.query'

const VideoUploadLinkQuery = ({ children }) => (
  <Query query={VIDEO_UPLOAD_LINK_QUERY}>{children}</Query>
)

export default VideoUploadLinkQuery



// WEBPACK FOOTER //
// ./src/components/VideoUploadLinkQuery.js